__turbopack_context__.v({
  "className": "barlow_condensed_73c8226c-module__2CECHq__className",
});
